import { create } from 'zustand';

interface UndoAction {
  id: string;
  label: string;
  undoFn: () => Promise<void>;
  createdAt: number;
}

interface UndoStore {
  lastAction: UndoAction | null;
  isUndoing: boolean;

  // Enregistrer une action annulable
  pushUndo: (label: string, undoFn: () => Promise<void>) => void;
  // Exécuter l'annulation
  undo: () => Promise<void>;
  // Vider (après expiration)
  clear: () => void;
}

export const useUndoStore = create<UndoStore>((set, get) => ({
  lastAction: null,
  isUndoing: false,

  pushUndo: (label, undoFn) => {
    set({
      lastAction: {
        id: `undo_${Date.now()}`,
        label,
        undoFn,
        createdAt: Date.now(),
      },
    });

    // Auto-expire après 10 secondes
    setTimeout(() => {
      const current = get().lastAction;
      if (current && Date.now() - current.createdAt >= 9500) {
        set({ lastAction: null });
      }
    }, 10000);
  },

  undo: async () => {
    const { lastAction, isUndoing } = get();
    if (!lastAction || isUndoing) return;

    set({ isUndoing: true });
    try {
      await lastAction.undoFn();
      set({ lastAction: null, isUndoing: false });
    } catch (err) {
      console.error('❌ Erreur undo:', err);
      set({ isUndoing: false });
    }
  },

  clear: () => set({ lastAction: null }),
}));
